import { action, computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Col, Row, Select, Tag, Typography } from 'antd';

import { DeleteOutlined } from '@ant-design/icons';
import IssueObject, {
  getPriorityTagColor,
  getPriorityTagDescription,
} from 'stores/Classes/IssueObject';

const { Text } = Typography;
const { Option } = Select;

class WorkOrderLineItemIssuesItemDesktop extends Component {
  static propTypes = {
    childRef: PropTypes.func,
    item: PropTypes.object,
    onRemoveItem: PropTypes.func,
    currentCarIssues: PropTypes.array,
    onUpdateLocalItem: PropTypes.func.isRequired,
  };

  localItem = {
    id_vehicle_service: '',
  };

  currentCarIssues = [];

  constructor(props) {
    super(props);
    makeObservable(this, {
      localItem: observable,
      currentCarIssues: observable,
      localCurrentCarIssues: computed,
      issuesOptions: computed,
      updateLocalItem: action,
      updateCurrentCarIssues: action,
      onChangeSelectField: action,
    });
    this.updateCurrentCarIssues(props.currentCarIssues || []);
  }

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);
    this.updateLocalItem(this.props.item);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentCarIssues !== this.props.currentCarIssues) {
      this.updateCurrentCarIssues(this.props.currentCarIssues || []);
    }
    if (prevProps.item !== this.props.item) {
      this.updateLocalItem(this.props.item);
    }
  }

  updateLocalItem = (value) => {
    this.localItem = value;
  };

  updateCurrentCarIssues = (value) => {
    this.currentCarIssues = value;
  };

  get localCurrentCarIssues() {
    return this.currentCarIssues;
  }

  get issuesOptions() {
    const formatLabel = (issue) => {
      const issueObject = new IssueObject(issue);
      return (
        <>
          <Tag color={getPriorityTagColor(issue.priority)}>
            {getPriorityTagDescription(issue.priority)}
          </Tag>
          <Text>{issueObject.getName()}</Text>
        </>
      );
    };
    return this.localCurrentCarIssues.map((issue, index) => (
      <Option key={index} value={issue.id}>
        {formatLabel(issue)}
      </Option>
    ));
  }

  onChangeSelectField = (value, fieldName) => {
    this.updateLocalItem({
      ...this.localItem,
      [fieldName]: value,
    });

    if (this.props.onUpdateLocalItem) {
      this.props.onUpdateLocalItem(this.localItem);
    }
  };

  onRemoveItem = (event, itemKey) => {
    if (this.props.onRemoveItem) {
      this.props.onRemoveItem(event, itemKey);
    }
  };

  render() {
    return (
      <Row style={{ margin: 0 }} gutter={[8, 8]}>
        <Col key={'name'} span={23}>
          <Text strong>Issue</Text>
          <Select
            value={this.localItem.id_vehicle_service}
            onChange={(value) =>
              this.onChangeSelectField(value, 'id_vehicle_service')
            }
            placeholder="Select a Issue"
          >
            {this.issuesOptions}
          </Select>
        </Col>
        <Col
          key={'deleteBtn'}
          span={1}
          style={{
            display: 'flex',
            height: '57px',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '25px',
          }}
        >
          <DeleteOutlined
            onClick={(event) => {
              event.stopPropagation();
              this.onRemoveItem(event, this.props.item.key);
            }}
          />
        </Col>
      </Row>
    );
  }
}

export default observer(WorkOrderLineItemIssuesItemDesktop);
